// What a draft is, relative to its published copy.
//
// One function for the API resolver and the app's listing column, the way
// site-pack/status is, so the badge on screen cannot disagree with what the
// server says.
//
// `changed` is the state gen-2 could not show: it kept the draft and the copy
// in two tables with nothing linking their times, so the only way to learn a
// published post had unpublished edits was to open both. `editedAt` is stamped
// by every content write and by nothing else (see ./fields), so a plain
// comparison answers it.
export const DRAFT = "draft";
export const PUBLISHED = "published";
export const CHANGED = "changed";

export const STATUSES = [DRAFT, PUBLISHED, CHANGED];

export const statusOf = (post) => {
  if (!post || !post.publishedAt) {
    return DRAFT;
  }

  return post.editedAt && post.editedAt > post.publishedAt ? CHANGED : PUBLISHED;
};

export const isPublished = (post) => statusOf(post) !== DRAFT;
